export const CARTEVITALE_LESSONS_AR = [
  {
    id: 'cartevitale-1',
    numero: 1,
    titre: "فهم بطاقتك الحيوية",
    sousTitre: "ما هي وكيف تعمل؟",
    contexte: "البطاقة الحيوية هي بطاقتك الصحية الفرنسية. إليك كل ما تحتاج معرفته لاستخدامها بشكل صحيح.",
    explication: [
      "**البطاقة الحيوية** تُثبت حقوقك في التأمين الصحي. قدّمها لكل طبيب أو صيدلاني لتلقي رعايتك وتسهيل التسديد.",
      "**رقم الضمان الاجتماعي** مكوّن من 15 رقماً ومطبوع على البطاقة. إنه معرّفك الفريد مع نظام الرعاية الصحية.",
      "**في حالة الفقدان**: اتصل بـ 36 46 (مجاني من الهاتف الثابت) أو اطلب بطاقة جديدة على ameli.fr.",
      "**البطاقة لا تنتهي صلاحيتها** — تبقى سارية طالما أنت مؤمَّن. لكن يجب تحديثها عند كل تغيير في وضعك.",
      "**إذا نسيت بطاقتك**: الطبيب يمكنه إدخال رقمك يدوياً. في الصيدلانية، احتفظ بوصفتك وادفع ثم استرد.",
    ],
    question: "ما الرقم الذي يجب الاتصال به في حالة فقدان البطاقة الحيوية؟",
    options: [
      { id: 'a', text: "36 46", correct: true },
      { id: 'b', text: "15", correct: false },
      { id: 'c', text: "3230", correct: false },
    ],
    explication_reponse: "الرقم 36 46 هو رقم Ameli للمؤمَّنين. مجاني من الهاتف الثابت. يمكنك أيضاً طلب بطاقة جديدة مباشرة على ameli.fr في قسم 'خدماتي'.",
  },
  {
    id: 'cartevitale-2',
    numero: 2,
    titre: "إنشاء واستخدام فضاء Ameli",
    sousTitre: "موقعك الصحي الشخصي",
    contexte: "ameli.fr هو موقعك لإدارة كل شيء يتعلق بتأمينك الصحي. إليك كيفية إنشاء حسابك.",
    explication: [
      "**أنشئ حسابك** على ameli.fr ← 'إنشاء حسابي'. ستحتاج: رقم الضمان الاجتماعي، تاريخ الميلاد، عنوان البريد الإلكتروني.",
      "**ما يمكنك فعله**: التحقق من حقوقك، تنزيل شهادة الحقوق، الاطلاع على تسديداتك، طلب بطاقة حيوية جديدة.",
      "**شهادة الحقوق** تُثبت تأمينك الصحي — مطلوبة من الأطباء والمستشفيات والصيادلة. قابلة للتنزيل في 30 ثانية.",
      "**تطبيق Ameli**: نفس الخدمات على هاتفك — سريع ومريح لمعرفة حالة تسديداتك في أي وقت.",
      "**المراسلة الإلكترونية**: أرسل أسئلتك مباشرة إلى صندوق Assurance Maladie دون الانتظار هاتفياً.",
    ],
    question: "أين تجد شهادة حقوقك الصحية بسرعة؟",
    options: [
      { id: 'a', text: "على ameli.fr في فضائك الشخصي — في 30 ثانية", correct: true },
      { id: 'b', text: "بالتوجه إلى CPAM بوثيقة هوية", correct: false },
      { id: 'c', text: "بالاتصال بـ 36 46 وانتظار رسالة بريدية", correct: false },
    ],
    explication_reponse: "شهادة الحقوق متاحة فوراً على ameli.fr أو التطبيق — 24/24. إنها من أكثر الوثائق طلباً من الأطباء والمستشفيات.",
  },
  {
    id: 'cartevitale-3',
    numero: 3,
    titre: "تحديث بطاقتك الحيوية",
    sousTitre: "متى وكيف؟",
    contexte: "البطاقة الحيوية تحتاج تحديثاً منتظماً لتعكس وضعك الصحي الحقيقي. إليك متى وكيف تفعل ذلك.",
    explication: [
      "**تحديث في الصيدلانية**: أدخل بطاقتك في الجهاز الأخضر (borne de mise à jour) الموجود في معظم الصيدليات. مجاني وسريع.",
      "**متى يجب التحديث؟** بعد ولادة، زواج، طلاق، تغيير في الوضع المهني، أو كل سنة للحفاظ على البيانات محدّثة.",
      "**البطاقة الرقمية Ameli**: يمكنك استخدام تطبيق Ameli كبطاقة رقمية على هاتفك — مقبولة لدى معظم المهنيين الصحيين.",
      "**في حالة تغيير الطبيب المعالج**: يجب تحديث البطاقة في الصيدلانية بعد التسجيل عند الطبيب الجديد.",
      "**لا تقلق إذا نسيت**: الطبيب يمكنه دائماً إدخال رقمك يدوياً — التحديث يبقى مهماً للاستفادة الكاملة من حقوقك.",
    ],
    question: "أين يمكنك تحديث بطاقتك الحيوية مجاناً؟",
    options: [
      { id: 'a', text: "في الجهاز الأخضر بالصيدلانية", correct: true },
      { id: 'b', text: "في مكتب CPAM فقط", correct: false },
      { id: 'c', text: "عند طبيبك المعالج فقط", correct: false },
    ],
    explication_reponse: "الجهاز الأخضر للتحديث موجود في معظم الصيدليات — مجاني وسريع. أدخل البطاقة وانتظر 30 ثانية. يمكنك أيضاً استخدام التطبيق كبديل رقمي.",
  },
  {
    id: 'cartevitale-4',
    numero: 4,
    titre: "فهم تسديداتك",
    sousTitre: "من يدفع ماذا؟",
    contexte: "زرت طبيباً ودفعت. كم ستسترد؟ كيف يعمل نظام التسديد؟",
    explication: [
      "**التسديد القاعدي**: الضمان الاجتماعي يُسدّد عادةً 70% من التعريفة الرسمية. الـ 30% المتبقية تسمى 'الحصة النظامية'.",
      "**الطبيب المعالج**: إذا كان لديك طبيب معالج معلَّن، تستفيد من أفضل تسديد. بدونه، يتضاعف الجزء غير المسدَّد.",
      "**المسار التنسيقي للرعاية**: مرر دائماً عبر طبيبك المعالج قبل زيارة متخصص — وإلا ستُخفَّض تسديداتك.",
      "**CSS (التغطية الصحية التكميلية)**: إذا كان دخلك محدوداً، يمكنك الحصول على CSS مجاناً — تُغطي ما لا يُسدّده الضمان الاجتماعي.",
      "**مهلة التسديد**: عادةً 5 إلى 7 أيام عمل بعد الزيارة، مباشرة في حسابك البنكي.",
    ],
    question: "ما نسبة التسديد القاعدي للضمان الاجتماعي عند زيارة الطبيب المعالج؟",
    options: [
      { id: 'a', text: "70% من التعريفة الرسمية", correct: true },
      { id: 'b', text: "100% دائماً", correct: false },
      { id: 'c', text: "50% فقط", correct: false },
    ],
    explication_reponse: "الضمان الاجتماعي يُسدّد 70% للطبيب المعالج. الـ 30% المتبقية يمكن تغطيتها بتأمين تكميلي (mutuelle) أو CSS إذا كنت مستحقاً.",
  },
];
